const routes = {
  rates: 'תעריפים',
  parents: 'הורים',
  newScenario: 'תרחיש חדש',
  viewSites: 'הצג אתרים',
  sites: 'אתרים',
  attributes: 'מאפיינים',
  suppliers: 'ספקים',
  updateSupplier: 'עדכן ספק',
  createSupplier: 'הוסף ספק',
  shuttles: 'שאטלים',
  updateShuttle: 'עדכן שאטל',
  createShuttle: 'הוסף שאטלים',
  fares: 'דמי נסיעה',
  updateFare: 'עדכן תעריף',
  createFare: 'הוסף תעריף',
  services: 'שירותים',
  updateService: 'עדכן שירות',
  createService: 'הוסף שירות',
  users: 'משתמשים',
  updateUser: 'עדכן משתמש',
  createUser: 'הוסף משתמש',
  vehicles: 'רכבים',
  updateVehicle: 'עדכן רכב',
  createVehicle: 'הוסף רכב',
  areas: 'אזורים',
  updateArea: 'עדכן אזור',
  createArea: 'הוסף אזור',
  drivers: 'נהגים',
  updateDriver: 'עדכן נהג',
  createDriver: 'הוסף נהג',
  playground: 'מגרש משחקים',
  support: 'תמיכה',
  parameters: 'פרמטרים',
  createParameter: 'הוסף פרמטר',
  analytics: 'ניתוחים',
  settings: 'הגדרות',
  liveMap: 'מפה חיה',
  driverShifts: 'משמרות נהגים',
  driverShiftsTemplates: 'תבניות משמרות',
  createDriverShift: 'הוסף משמרת נהג יחידה',
  createMultipleDriverShifts: 'הוסף משמרות נהגים מרובות',
  passengers: 'נוסעים',
  students: 'תלמידים',
  employees: 'עובדים',
  editShuttle: 'ערוך שאטל',
  updatePassenger: 'ערוך נוסע',
  createPassenger: 'נוסע חדש',
  onlineDrivers: 'נהגים מקוונים',
  trips: 'נסיעות',
  productionTrips: 'נסיעות ייצור',
  reservations: 'הזמנות',
  editReservation: 'ערוך הזמנה',
  createReservation: 'הוסף הזמנה',
  createQuick: 'הוסף הזמנה מהירה',
  timeline: 'ציר זמן',
  feedbacks: 'משובים',
  home: 'מרכז השליטה',
  import: 'העלאת נתונים',
  reports: 'דוחות',
  shuttleReports: 'דוחות שאטל',
  locations: 'מיקומים',
  createLocation: 'הוסף מיקום',
  editLocation: 'עדכן מיקום',
  profiles: 'פרופילים',
  shifts: 'משמרות',
  createShift: 'הוסף משמרת',
  updateShift: 'עדכן משמרת',
  agentHome: 'סוכן',
  createExtraService: 'הוסף שירות נוסף',
  updateExtraService: 'עדכן שירות נוסף',
  extraServices: 'שירותים נוספים',
  tripsPaxReports: 'סיכום נסיעות / נוסעים',
  uniqueDriversReport: 'נהגים ייחודיים ליום',
  permissions: 'תפקידים והרשאות',
  createJob: 'הוסף הזמנה',
  quickJob: 'הזמנה מהירה',
  onboarding: 'בונה תרחישים - NEMT',
  holidays: 'חגים',
  blacklist: 'כרטיסי תשלום חסומים',
  integrations: 'אינטגרציות',
  automations: 'אוטומציות',
  jobsCalendar: 'לוח הזמנות',
  caregivers: 'מטפלים',
  customRules: 'כללים מותאמים',
  billReports: 'דו”ח הזמנות',
  performanceOverview: 'סקירת ביצועים',
  facilities: 'מתקנים',
  roiSimulation: 'סימולציית ROI',
  apiKeys: 'מפתחות API',
};

export default routes;
